import { Box, Typography, useMediaQuery, Stack, Button, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import homePage from "../assets/img/homePage.png";
import { useLoader } from "../context/LoaderContext";
import axios from "axios";
import { host } from "../constant/backendpath";
import ProjectCounter from "../widgets/Counter";

const yearlyStatistics = {
  2024: {
    projects: 100,
    winners: 24,
    participants: 400,
  },
  2025: {
    projects: 138,
    winners: 31,
    participants: 512,
  },
};

const fetchStatistics = async () => {
  // TODO: Replace this temporary object with a backend API call once the Statistics API is implemented.
  return yearlyStatistics;
};

const Home = ({ isLogged, setIsLogged, setCurrent }) => {
  const isMobile = useMediaQuery("(max-width:735px)");
  const { setLoading } = useLoader();
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClassYear, setSelectedClassYear] = useState("");
  const [statistics, setStatistics] = useState({ projects: 0, winners: 0, participants: 0 });
  const [availableProjectYears, setAvailableProjectYears] = useState([]);
  const [availableClassYears, setAvailableClassYears] = useState([]);

  function handleLogin() {
    // console.log('home'+isLogged)
    if (!isLogged) {
      // console.log('hi');
      setCurrent(4);
    } else {
      setCurrent(2);
    }
  }

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const res = await axios.get(`${host}home`, { withCredentials: true });

        if (res.status === 200) {
          // console.log('user found');
          setIsLogged(true);
        }
      } catch (err) {
        // console.log('user not found');
        setIsLogged(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const loadStatistics = async () => {
      const data = await fetchStatistics();
      const years = Object.keys(data).sort((a, b) => Number(b) - Number(a));
      const latestYear = years[0] || "";
      setSelectedYear(latestYear);
      if (latestYear) {
        setStatistics(data[latestYear]);
      }
    };

    loadStatistics();
    // fetch available years for dropdowns
    (async function loadYears() {
      try {
        const res = await axios.get(`${host}project/years`, { withCredentials: true });
        if (res.status === 200) {
          const { projectYears = [], classYears = [] } = res.data || {};
          setAvailableProjectYears(projectYears || []);
          setAvailableClassYears(classYears || []);
          if (!selectedYear && projectYears && projectYears.length) setSelectedYear(String(projectYears[0]));
          if (classYears && classYears.length) setSelectedClassYear(String(classYears[0]));
        }
      } catch (err) {
        // ignore if backend not present
      }
    })();
  }, []);

  useEffect(() => {
    if (!selectedYear) return;
    const selectedStats = yearlyStatistics[selectedYear];
    if (selectedStats) {
      setStatistics(selectedStats);
    }
  }, [selectedYear]);

  // Fetch real stats from backend when project year or class year changes
  useEffect(() => {
    async function fetchStats() {
      try {
        const params = {};
        if (selectedYear) params.year = selectedYear;
        if (selectedClassYear) params.classYear = selectedClassYear;
        const res = await axios.get(`${host}project/stats`, { params, withCredentials: true });
        if (res.status === 200 && res.data) {
          setStatistics(res.data);
          return;
        }
      } catch (err) {
        // ignore and keep simulated data
      }

      // fallback to simulated yearlyStatistics if backend fails
      if (selectedYear && yearlyStatistics[selectedYear]) {
        setStatistics(yearlyStatistics[selectedYear]);
      }
    }

    fetchStats();
  }, [selectedYear, selectedClassYear]);

  return (
    <Box
      sx={{
        mt: 8,
        px: { xs: 2, md: 6 },
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 4,
        }}
      >
        <Box sx={{ flex: 1, width: isMobile ? "100%" : "50%" }}>
          <Typography
            variant="h3"
            color="primary"
            fontWeight="bold"
            sx={{ lineHeight: 1.2 }}
          >
            TURN IDEAS
          </Typography>
          <Typography component="span" variant="h3" fontWeight="bold">
            INTO INNOVATIVE WITH <br />
          </Typography>
          <Typography
            component="span"
            variant="h3"
            color="primary"
            fontWeight="bold"
          >
            THIRAN
          </Typography>
          <Typography
            variant="body1"
            sx={{ mt: 2, fontSize: "1.1rem", color: "text.primary" }}
          >
            Thiran is more than just a platform, it's a launchpad for innovation
            at our college. Whether you're working on a groundbreaking project,
            collaborating with peers, or showcasing your expertise.
          </Typography>
          {/* <Typography variant="body1" sx={{ mt: 2, fontSize: "1.1rem", color: "red" }}>
                    Registration opens for first years
          </Typography> */}
          <Stack direction="row" mt={3}>
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "30px", width: "150px" }}
              onClick={handleLogin}
            >
              Register
            </Button>
          </Stack>
        </Box>
        <Box
          component="img"
          src={homePage}
          alt="Home illustration"
          sx={{
            display: isMobile ? "none" : "flex",
            width: "30%",
            height: "auto",
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          boxShadow: 1,
          p: 3,
          borderRadius: 2,
          bgcolor: "#fff",
          width: "95%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "flex-start" : "center",
            gap: 2,
            marginBottom: 2,
          }}
        >
          <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
            Project - Thiran {selectedYear}
          </Typography>
          <FormControl size="small" sx={{ width: "170px" }}>
            <InputLabel id="statistics-year-label">Year</InputLabel>
            <Select
              labelId="statistics-year-label"
              value={selectedYear}
              label="Year"
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {(availableProjectYears.length ? availableProjectYears : Object.keys(yearlyStatistics))
                .sort((a, b) => Number(b) - Number(a))
                .map((year) => (
                  <MenuItem value={year} key={year}>
                    {year}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-around",
            width: "100%",
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ProjectCounter total={statistics.projects} />
            <Box>
              <Typography>Projects Count</Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ProjectCounter total={statistics.winners} />
            <Box>
              <Typography>Winners Count</Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ProjectCounter total={statistics.participants} />
            <Box>
              <Typography>Participants Count</Typography>
            </Box>
          </Box>
        </Box>
        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 3, fontStyle: "italic", fontSize: "1rem" }}
        >
          "Winners are not who never fail, but those who never quit"
        </Typography>
      </Box>
    </Box>
  );
};


export default Home;
